<template>
  <div class="opc-users-change-container" v-show="show">
    {{ text }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { plansof } from '@/utils/chain';
import { getPlanUnitByQuantity,planUnitMap } from '@/common/product-unit';
export default {
  name: 'UsersChange',
  props: {
    type: String,
    value: Number,
    unit: Number,
    code: String,
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans', 'oldPlanCode']),
    show() {
      return this.cartPlan?.cartInfo?.selected_number &&
        this.boughtPlan?.cartInfo?.selected_number &&
        this.cartPlan?.cartInfo?.selected_number !== this.boughtPlan?.cartInfo?.selected_number;
    },
    changes() {
      return `${this.changesNumber > 0 ? '+' : ''}${this.changesNumber}`;
    },
    text() {
      const unitDesc = getPlanUnitByQuantity(this.unit ?? planUnitMap.user, this.changesNumber);
      return this.changesNumber > 0 ?
        this.$t('billing.simplify.change_increase_users', [this.changes, unitDesc]) :
        this.$t('billing.simplify.change_decrease_users', [this.changes, unitDesc])
    },
    changesNumber() {
      return this.show ?
        this.cartPlan?.cartInfo?.selected_number - this.boughtPlan?.cartInfo?.selected_number :
        0;
    },
    cartPlan() {
      if(this.code) return plansof(this.getSelectedPlans).code(this.code).get(0);
      return plansof(this.getSelectedPlans).type(this.type).get(0);
    },
    boughtPlan() {
      return plansof(this.boughtPlans).type(this.type).code(this.oldPlanCode).get(0);
    },
  }
}
</script>

<style lang="scss" scoped>
.opc-users-change-container {
  color: var(--zoom-color-text-neutral, #686F79);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 4px;
}
</style>
